import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ImageFullSpaceDirective } from './image-full-space.directive';

@NgModule({
    declarations: [ImageFullSpaceDirective],
    imports: [CommonModule],
    exports: [ImageFullSpaceDirective]
})
export class ImageFullSpaceModule {}
